import { Action, Types } from "./hrLeaveEntitlementsTable.actions"

export type HrLeaveEntitlementsTableState = {
  data: string[]
}

const initialState: HrLeaveEntitlementsTableState = {
  data: ["hr_code_title=desc"],
}

export default (state = initialState, action: Action): HrLeaveEntitlementsTableState => {
  switch (action.type) {
    case Types.CHANGE_SORT:
      return {
        ...state,
        data: action.payload.sort,
      }

    default:
      return state
  }
}
